import { toDataURL } from "qrcode"
import { useEffect } from "react"
import { MdOutlineEventAvailable } from "react-icons/md"
import { useParams } from "react-router-dom"
import { getEventDoc, getGuestDoc, updateGuestStatus } from "../../Requests/firebaseFirestore"
import { uploadGuestQrCode } from "../../Requests/firebaseStorage"
import { sendGuestQrCode } from "../../Requests/sendMail"

export default function ThanksPage(){
  const {guestId} = useParams()

  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  const updateGuest = async () => {
    try {
      const guest = await getGuestDoc(guestId)
      if(guest.status==='pending'){
        const event = await getEventDoc(guest.event)
        await updateGuestStatus(guestId)
        const qr = await toDataURL(guestId)
        const qrUrl = await uploadGuestQrCode(qr, guestId, guest.event)
        await sendGuestQrCode({email:guest.email, event:event, qrUrl:qrUrl})
      }
    } catch (error) {
    }
  }
  

  useEffect(()=>{
    updateGuest()
  },[])

  return <div className="container mx-auto px-4">
      <div className="w-full sm:w-96 mx-auto sm:mx-0 mb-4">
        <img alt="Channel Talks logo" src={require('../../Assets/channeltalks-white.png')}/>
        <img alt="Channel Talks logo" src={require('../../Assets/slogan-white.png')}/>
      </div>
    <div className="bg-white mx-auto w-[50%] min-w-[350px] rounded-[10px] px-4 py-3 flex flex-col justify-center items-center gap-4">
      <span className="text-rose-500"><MdOutlineEventAvailable size={150}/></span>
      <h1 className="text-xl font-semibold">Gracias por aceptar</h1>
      <span className="text-center text-lg">Su email ha sido confirmado, le hemos enviado un correo con la información necesaria para el ingreso al evento</span>
      <span className="text-lg">Lo esperamos!</span>
    </div>
  </div>
}